'use client'
import React from 'react'
import { useTranslations } from '@/lib/next-shim'

import CheckboxInputController from '@/components/ui/inputs/CheckboxInputController'
import TextInputController from '@/components/ui/inputs/TextInputController'
import { LoadingButton } from '@/components/external/material'
import { Link } from '@/lib/next-shim'

import { CubeSanteRegisterFormData, useCubeSanteRegisterForm } from '../model/cubeSanteRegisterForm'
import { SubmitHandler } from 'react-hook-form'

type CubeSanteRegisterFormProps = {
  isLoading?: boolean
  onSubmit: SubmitHandler<CubeSanteRegisterFormData>
}

export function CubeSanteRegisterForm({ isLoading = false, onSubmit }: CubeSanteRegisterFormProps) {
  const {
    control,
    formState: { isValid },
    handleSubmit,
  } = useCubeSanteRegisterForm()
  const t = useTranslations()

  return (
    <form className="flex flex-col space-y-4" onSubmit={handleSubmit(onSubmit)}>
      {/* Basic Information */}
      <div>
        <TextInputController control={control} fullWidth label={t('field.email.label')} name="email" required />
      </div>
      <div>
        <TextInputController control={control} fullWidth label={t('field.name.label')} name="name" required />
      </div>
      <div>
        <TextInputController control={control} fullWidth label={t('field.surname.label')} name="surname" required />
      </div>
      <div>
        <TextInputController control={control} fullWidth label={t('page.Register.phoneOptional')} name="phone" />
      </div>

      {/* Password Section */}
      <div className="pt-4 border-t border-gray-200">
        <div className="space-y-4">
          <div>
            <TextInputController control={control} fullWidth label={t('field.password.label')} name="password" TextInputProps={{ type: 'password' }} required />
          </div>
          <div>
            <TextInputController control={control} fullWidth label={t('field.confirmPassword.label')} name="confirmPassword" TextInputProps={{ type: 'password' }} required />
          </div>
        </div>
      </div>

      {/* Terms and Submit */}
      <div className="flex items-start">
        <CheckboxInputController
          control={control}
          label={
            <div className="font-light text-gray-500">
              {t.rich('page.Register.signUpForm.field.termsAndConditions.label', {
                link: (chunks: React.ReactNode) => (
                  <Link className="font-medium text-primary-600 hover:underline" href="/terms-and-conditions" target="_blank">
                    {chunks}
                  </Link>
                ),
              })}
            </div>
          }
          name="terms"
        />
      </div>
      <LoadingButton
        className="w-full py-5 font-medium rounded-lg text-sm"
        disabled={!isValid}
        disableElevation
        loading={isLoading}
        type="submit"
        variant="contained"
      >
        {t('button.signUp.label')}
      </LoadingButton>
    </form>
  )
}
